import React, { useEffect } from 'react';
import { Col, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import LogoIcon from '../../assets/images/png/hat-logo-background.png';
import LogoText from '../../assets/images/png/logo-square.png';
import { SettingsRouteProps } from './Settings';
import { useSelector } from 'react-redux';
import { getSettingsState } from '../../store/settings/selector';

export const AboutUs: React.FC<SettingsRouteProps> = ({ setHeaderTitle }) => {
  const { settings } = useSelector(getSettingsState);
  const { t } = useTranslation();
  const setHeader: React.EffectCallback = () => {
    if (setHeaderTitle) setHeaderTitle('About Us');
  };

  useEffect(setHeader, [setHeaderTitle]);
  return (
    <React.Fragment>
      <Col className="about-us-block margin-top">
        <img src={LogoIcon} alt="" style={{ height: 95, width: 95 }} />
        <div className="about-us-app">
          MyCookAround
          <span>Version 1.0</span>
        </div>
      </Col>
      <Col className="about-us-block">
        <img src={LogoText} alt="" style={{ height: 55, width: 73 }} />
        <Typography.Paragraph className="margin-top">
          {/* {settings.aboutus} */}
          {t(`${settings.aboutus}`)}
        </Typography.Paragraph>
      </Col>
    </React.Fragment>
  );
};
